import React, { FC, useState } from "react";
import useMediaQueries from "hooks/useMediaQueries.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import InvitationEmailCard from "../ProfileUser/Profile/SubUsers/InvitationEmailCard.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import InvitationLinkCard from "../ProfileUser/Profile/SubUsers/InvitationLinkCard.js";

import "./inviteSubUserComponent.scss";

interface IInviteSubUserComponent {
  pageType: "invite" | "subuser";
}

const JoinHtml = () => {
  const { getTextByKey } = useContent();
  return (
    <div className="finished-join-sub-user">
      <div className="title">
        {getTextByKey("finished-join-sub-user-title")}
      </div>
      <div className="text">{getTextByKey("finished-join-sub-user-text")}</div>
      {/*@ts-ignore*/}
      <LinkToNewTab page="home">
        <Button medium>{getTextByKey("finished-join-sub-user-button")}</Button>
      </LinkToNewTab>
    </div>
  );
};

const InviteSubUserComponent: FC<IInviteSubUserComponent> = ({ pageType }) => {
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();

  const [join, setJoin] = useState(false);
  const [profileLogo, setProfileLogo] = useState(null);

  const isDefaultLogo = profileLogo === "default";

  return (
    <div className="page-wrapper-sub-user-by-link-complete">
      <div className="addition-sub-user-by-link">
        <div className={`yellow-icon${isDefaultLogo ? " default-logo" : ""}`}>
          {profileLogo ? (
            isDefaultLogo ? (
              <Icon name={"vertical-logo-mail-text"} />
            ) : (
              <Image
                src={profileLogo}
                className="profile-logo"
                hideTitle={true}
              />
            )
          ) : null}
        </div>
        {join ? (
          <JoinHtml />
        ) : (
          <>
            <h1>{getTextByKey("addition-sub-user-complete-title")}</h1>
            {pageType === "subuser" ? (
              <InvitationEmailCard
                setJoin={setJoin}
                setProfileLogo={setProfileLogo}
              />
            ) : (
              <InvitationLinkCard
                setJoin={setJoin}
                setProfileLogo={setProfileLogo}
              />
            )}
          </>
        )}
      </div>
      <div className="clouds-image-wrapper">
        <Image
          name={`sub-user-complete${mobileCondition ? "-mobile" : ""}`}
          className="clouds-image"
          hideTitle={true}
        />
      </div>
    </div>
  );
};

export default InviteSubUserComponent;
